import React from 'react';
import ButtonChoice from '../Fields/ButtonChoice';

const IncludeFloodCover = React.createClass({
    propTypes: {
        regenerateQuote: React.PropTypes.func,
    },
    
    regenerateQuote : function() {
        this.props.regenerateQuote();
    },

    render() {
        return (
            <div className="container has-border">
                <div className="summary-question">
                    <ButtonChoice
                        question={'Your property is in a flood risk area, would you like flood cover?'}
                        fieldName={'include_flood_cover'}
                        loadCachedValue={true}
                        children={[]}
                        questionId={null}
                        supplementaryText={''}
                        supplementaryTextAfterInput={null}
                        alternateBackground={null}
                        noBorder={true}
                        onChangeTertiary={this.regenerateQuote}
                        helpText={null}
                        options={[
                            {
                                option_text: 'Yes',
                                option_value: 'yes'
                            },
                            {
                                option_text: 'No',
                                option_value: 'no'
                            }
                        ]} />
                </div>
            </div>
        );
    }
});

export default IncludeFloodCover;



/** WEBPACK FOOTER **
 ** ./src/components/QuoteSummaryFields/IncludeFloodCover.js
 **/